export * from './public_api';
export { _firebaseAppFactory as ɵa } from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/ThinkBIT/work-projects/confe/hosting/~/angularfire2/index.js
// module id = ../../../../angularfire2/index.js
// module chunks = 22